import { authConstants } from "@constants";
import { secureStroge, storgeKeys } from "@utils";

export const auth = (state = {}, action) => {
  switch (action.type) {
    case authConstants.LOGIN_SUCCESS:
    case authConstants.THIRDPARTY_LOGIN_SUCCESS:
    case authConstants.THIRDPARTY_REGISTER_SUCCESS:
    case authConstants.REFRESH_CREDENTIAL:
      const newPermissions = [...action.userInfo.permissions];

      secureStroge.set(storgeKeys.userCredential, {
        uuid: action.userInfo.uuid,
        token: action.userInfo.token,
        roles: action.userInfo.roles,
        permissions: newPermissions,
        propertyModules: action.userInfo.property_modules
      });

      // 轉換 permission 資料結構，加速確認權限時的效能
      const newPermissionsMap = newPermissions.reduce((permissionsMap, permission) => {
        permissionsMap.set(permission.key, permission);
        return permissionsMap;
      }, new Map());

      return Object.assign({}, state, {
        ...state,
        userInfo: action.userInfo,
        userPermissions: newPermissions,
        userPermissionsMap: newPermissionsMap
      });

    case authConstants.LOGIN_FAILURE:
    case authConstants.LOGOUT:
      secureStroge.remove(storgeKeys.userCredential);
      return {};
    default:
      return state;
  }
};
